/**
 * State for events
 */
export const state = {
  /**
   * Weather the event is validated or not
   */
  validated: false
};
